import script from "./LecturesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LecturesView.vue?vue&type=script&lang=ts&setup=true"

import "./LecturesView.vue?vue&type=style&index=0&id=4e4b1066&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4b1066"]])

export default __exports__